import script from "./WidgetRaccourcis.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetRaccourcis.vue?vue&type=script&setup=true&lang=js"

import "./WidgetRaccourcis.vue?vue&type=style&index=0&id=8301a462&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8301a462"]])

export default __exports__